import React from "react";
import { RelatedCategoriesResult } from "~/common/Store/models/Category";
import RelatedCategoryHeader from "./RelatedCategoryHeader";
import RelatedCarousel from "./RelatedCarousel";

interface Props {
  relatedCategories: RelatedCategoriesResult[];
  parentCategoryName: string;
  categoryName: string;
}

const RelatedCategoryCarousel = ({
  relatedCategories,
  parentCategoryName,
  categoryName,
}: Props) => (
  <>
    {relatedCategories && relatedCategories.length > 0 && (
      <section className="carousel-wrap" aria-labelledby="carousel-heading">
        <RelatedCategoryHeader
          {...{
            categoryName,
            parentName: parentCategoryName,
          }}
        />
        <div
          id="other-products"
          className="basic-carousel carousel-box"
          data-component="carousel"
          data-testid="relatedCarousel"
          data-feature-name="otherCategories"
          data-gtm-component="carousel"
        >
          <RelatedCarousel relatedCategories={relatedCategories} />
        </div>
      </section>
    )}
  </>
);

export default RelatedCategoryCarousel;
